import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import {
  getUIText,
} from '../../utils/index';

import { version } from '../../utils/application-version';

function SplashScreenDialog({ open, app, translations, onClickHandler }) {
  return (

    <Dialog className="splash-screen" open={open}>
      <div className="title">
        <h1>{getUIText('APPLICATION-NAME', app.language, translations)}</h1>
        <p className="lead">{getUIText('APPLICATION-LONG_NAME', app.language, translations)}</p>
        <p className="iso-number">ISO 12241:2022</p>
      </div>
      <DialogContent>
        {/* <p className="description">Dear Calculus user, our calculation tool is moving cloud locations. We’re sorry that the Calculus service will be down shortly on Monday 25.10.2021 starting at 12:00 UTC. Thank you for your patience, and in case of any questions, please email craig.treanor@owenscorning.com</p> */}
        <p className="description">
          {getUIText('STARTUP_DIALOG-DISCLAIMER', app.language, translations) + ' '}
          {/* {getUIText("STARTUP_DIALOG-DISCLAIMER_2", app.language, translations)} */}
        </p>
        <Button color="primary" onClick={onClickHandler}>
          {getUIText('GENERAL-CONTINUE', app.language, translations)}
        </Button>
      </DialogContent>
      <div className="footer">
        <p>{getUIText('STARTUP_DIALOG-COPYRIGHT', app.language, translations).replace('2012', new Date().getFullYear())}</p>
        <p className="version-number">{version}</p>
      </div>
    </Dialog>
  );
}

SplashScreenDialog.propTypes = {
  app: PropTypes.any,
  onClickHandler: PropTypes.any,
  open: PropTypes.any,
  translations: PropTypes.any,
};

export default (SplashScreenDialog);
